import { Module } from 'vuex';
import { actions } from '@/store/stations/actions';
import { getters } from '@/store/stations/getters';
import { mutations } from '@/store/stations/mutations';
import { state } from '@/store/stations/state';
import { RootState } from '@/models/states/root-state.model';
import { StationsState } from '@/models/states/stations-state.model';

const namespaced: boolean = true;

export const stations: Module<StationsState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
